export const categories = [
  {
    slug: 'ethical-theory',
    name: '伦理理论',
    icon: 'ri-lightbulb-line',
    description: '探索伦理学基础理论，包括功利主义、义务论、美德伦理学等经典伦理学说，建立系统的伦理学知识框架。',
    color: 'primary',
  },
  {
    slug: 'applied-ethics',
    name: '应用伦理',
    icon: 'ri-scales-3-line',
    description: '关注现实场景中的伦理议题，涵盖生命伦理、环境伦理、科技伦理、商业伦理等前沿领域。',
    color: 'accent',
  },
  {
    slug: 'professional-ethics',
    name: '职业伦理',
    icon: 'ri-briefcase-line',
    description: '面向各行业的职业道德规范与职业操守培训，帮助从业者建立职业责任意识和伦理决策能力。',
    color: 'secondary',
  },
  {
    slug: 'case-analysis',
    name: '案例分析',
    icon: 'ri-file-search-line',
    description: '通过真实伦理案例的深度剖析，培养伦理敏感性和道德推理能力，在实践中学习伦理判断。',
    color: 'primary',
  },
  {
    slug: 'ethics-assessment',
    name: '伦理测评',
    icon: 'ri-survey-line',
    description: '提供科学的伦理认知测评工具，帮助个人和机构评估伦理素养水平，发现道德发展提升空间。',
    color: 'accent',
  },
];